export class TreeNode {
    constructor(props) {
        this.__children = null;
        this.__visible = true;
        this.__onChanged = null;
        this.__props = props;
        if (this.__props.root == null)
            this.__props.root = this;
    }
    get id() {
        return this.__props.node.id;
    }
    get icon() {
        return this.__props.node.icon;
    }
    get text() {
        return this.__props.node.text;
    }
    get tooltip() {
        return this.__props.node.tooltip;
    }
    get isCollapsed() {
        return this.__props.node.isCollapsed || false;
    }
    set isCollapsed(value) {
        this.__props.node.isCollapsed = value;
    }
    get isSelected() {
        return this.__props.node.isSelected || false;
    }
    set isSelected(value) {
        var _a;
        (_a = this.__props.root) === null || _a === void 0 ? void 0 : _a.clearSelection();
        this.__props.node.isSelected = value;
    }
    get parentId() {
        return this.__props.node.parentId;
    }
    get disabled() {
        return this.__props.node.disabled;
    }
    get style() {
        return this.__props.node.style;
    }
    get onClick() {
        return this.__props.node.onClick;
    }
    get onDoubleClick() {
        return this.__props.node.onDoubleClick;
    }
    get onContextMenu() {
        return this.__props.node.onContextMenu;
    }
    get onRenderTooltip() {
        return this.__props.node.onRenderTooltip;
    }
    get onDragStart() {
        return this.__props.node.onDragStart;
    }
    set onChanged(value) {
        this.__onChanged = value;
    }
    get children() {
        if (this.__children == null) {
            const parentId = this.__props.node.id;
            this.__children = this.__props.allNodes
                .filter(o => o.parentId === parentId)
                .map(node => new TreeNode({
                allNodes: this.__props.allNodes,
                node: node,
                root: this.__props.root
            }));
        }
        return this.__children;
    }
    get visible() {
        return this.__visible;
    }
    search(value) {
        this.__visible = true;
        value = value.toLowerCase();
        const isVisible = this.text.toLowerCase().indexOf(value) >= 0;
        const hasVisibleChildren = this.children.map(o => o.search(value)).filter(o => o).length > 0;
        this.__visible = isVisible || hasVisibleChildren;
        return this.__visible;
    }
    clearSelection() {
        if (this.__props.node.isSelected) {
            this.__props.node.isSelected = false;
            if (this.__onChanged != null)
                this.__onChanged();
        }
        if (this.children != null)
            this.children.forEach(o => o.clearSelection());
    }
    static createRootNode(nodes, rootNodeId = 'root') {
        const root = nodes.find(n => n.id == rootNodeId);
        if (root == null)
            throw new Error('Root node not found');
        const rootNode = new TreeNode({
            allNodes: nodes,
            node: root,
            root: null
        });
        return rootNode;
    }
}
